export default {
    updateMenuMiniState(state,{value}){
        state.menuMiniState = value
    },
    updateMenuMobileState(state,{value}){
        state.menuMobileState = value
    }
}